<template>
<div>
  <Navigation :location="location" />
  <router-view />
  <FooterComp />
</div>
</template>

<script>
import AOS from "aos";
import Navigation from "@/components/Navigation/index.vue";
import FooterComp from "@/components/Footer/index.vue";
export default {
  components: {
    Navigation,
    FooterComp
  },
  mounted() {
    AOS.init();
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

html {
  overflow-x: hidden;

  body {
    margin: 0;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
}

@font-face {
  font-family: bebas neue;
  src: url("./assets/fonts/BebasNeue.ttf");
}

@font-face {
  font-family: Montserrat;
  src: url("./assets/fonts/Montserrat-Regular.ttf");
  font-weight: 400;
}

@font-face {
  font-family: Montserrat;
  src: url("./assets/fonts/Montserrat-ExtraLight.ttf");
  font-weight: 200;
}

@font-face {
  font-family: Montserrat;
  src: url("./assets/fonts/Montserrat-Light.ttf");
  font-weight: 300;
}

@font-face {
  font-family: Montserrat;
  src: url("./assets/fonts/Montserrat-Medium.ttf");
  font-weight: 500;
}

@font-face {
  font-family: Montserrat;
  src: url("./assets/fonts/Montserrat-Bold.ttf");
  font-weight: 700;
}

@font-face {
  font-family: Montserrat;
  src: url("./assets/fonts/Montserrat-ExtraBold.ttf");
  font-weight: 800;
}

@font-face {
  font-family: Montserrat;
  src: url("./assets/fonts/Montserrat-Black.ttf");
  font-weight: 900;
}
</style>
